export const AddProductModel = {
    initModel: {
        amountGross: 0,
        amountNet: 0,
        amountGrossCradle: 0,
        amountNetCradle: 0
    },
    fieldNames: [
        'amountGross',
        'amountNet',
        'amountGrossCradle',
        'amountNetCradle'
    ],
    fieldsTypes: [
        'number',
        'number',
        'number',
        'number'
    ]
}